<template>
    <input type="hidden"
           :value="videoUrl"
           id="videoUrlText"
    >
    <a href="#" slot="reference" @click.stop.prevent="copyVideoLink">
        <div class="btn-icon-share-hover position-absolute">
            <img alt="Share" :src="getPathURL + 'videos/images/share-icon-link-1.svg'">
        </div>
        <div class="btn-icon-share-hover btn-icon-share">
            <img alt="Share" :src="getPathURL + 'videos/images/share-icon-link-2.svg'">
        </div>
    </a>
</template>
<script setup>
import { ref, computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';

// INIATIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    videoUrl: {
        type: String,
        default: '',
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const getPathURL = computed(() => {
    if (store.getPathLocalOrServer !== '') {
        return store.getPathLocalOrServer;
    }
    return '/uploads/';
});

// METHODS
const copyVideoLink = async () => {
    const tooltipID = $('#tooltipID');
    tooltipID.html('Copy Link');
    let url = props.videoUrl;
    const weblinkIDEnc = store.getWeblinkIDEncore;
    if (weblinkIDEnc !== '') {
        url = url + '/' + weblinkIDEnc;
    }
    console.log(url);
    try {
        await copyToClipboard(url);
        tooltipID.html('Copied');
    } catch (err) {
        await copyToClipboard(url, true);
        tooltipID.html('Copied');
    }
};

const copyToClipboard = async (textToCopy, jumpClipboard = false) => {
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext && !jumpClipboard) {
        await navigator.clipboard.writeText(textToCopy);
    } else {
        let textCodeToCopy = document.getElementById('videoUrlText');
        textCodeToCopy.value = textToCopy;
        textCodeToCopy.setAttribute('type', 'text');
        textCodeToCopy.select();

        try {
            document.execCommand('copy');
        } catch (error) {
            console.error(error);
        }

        textCodeToCopy.setAttribute('type', 'hidden');
        window.getSelection().removeAllRanges();
    }
};

// LIFECYCLE HOOKS
</script>
